import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/apiClient";
import PlayVoice from "@/components/routine/PlayVoice";

const localDate = () => new Date().toLocaleDateString("en-CA");
const DAY = ["M", "T", "W", "T", "F", "S", "S"];

// Monday–Sunday immersion rhythm: a dot lights on each day he completed one.
export default function ImmersionWeek() {
  const [w, setW] = useState(null);
  useEffect(() => { api.get("/routine/immersion-week", { params: { local_date: localDate() } }).then((r) => setW(r.data)).catch(() => {}); }, []);
  if (!w) return null;
  const n = Math.min(w.count, w.goal);
  const r = w.reflection;
  return (
    <>
    {r && (
      <section className="mb-10 rounded-3xl border border-primary/20 bg-card/40 p-5 sm:p-6" data-testid="routine-immersion-reflection">
        <p className="text-[10px] uppercase tracking-[0.22em] text-primary">{r.coach} · your week, reflected</p>
        <div className="flex items-start gap-3 mt-2">
          <PlayVoice label={`Hear ${r.coach}`} testId="immersion-reflection-play"
            load={async () => (await api.post("/routine/immersion-reflection/audio", null, { params: { local_date: localDate() } })).data.audio} />
          <p className="font-serif text-lg sm:text-xl leading-snug" data-testid="immersion-reflection-text">{r.text}</p>
        </div>
      </section>
    )}
    <section className="mb-10 rounded-3xl border border-white/10 bg-card/40 p-5 sm:p-6" data-testid="routine-immersion-week">
      <div className="flex items-baseline justify-between mb-4">
        <p className="text-[10px] uppercase tracking-[0.22em] text-primary">Immersion rhythm</p>
        <p className="text-xs text-muted-foreground" data-testid="immersion-week-count">
          {w.count >= w.goal ? `${w.count} this week · milestone reached` : `${n} of ${w.goal} this week`}
        </p>
      </div>
      <div className="flex justify-between max-w-sm">
        {w.days.map((d, i) => (
          <div key={d.date} className="flex flex-col items-center gap-2" data-testid={`immersion-week-day-${i}`} data-done={d.done}>
            <span className={`w-3.5 h-3.5 rounded-full transition-[background-color,box-shadow] duration-500 ${d.done ? "bg-primary shadow-[0_0_14px_hsl(var(--primary)/0.6)]" : "border border-white/20"} ${d.date === w.today && !d.done ? "border-primary/70" : ""}`} />
            <span className={`text-[10px] ${d.date === w.today ? "text-foreground" : "text-muted-foreground"}`}>{DAY[i]}</span>
          </div>
        ))}
      </div>
      {w.nudge && (
        <div className="mt-5 pt-4 border-t border-white/10" data-testid="immersion-week-nudge">
          <p className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground mb-1.5">{w.nudge.coach}</p>
          <p className="font-serif text-base sm:text-lg leading-snug mb-3" data-testid="immersion-week-nudge-text">{w.nudge.text}</p>
          <Link to={w.nudge.route} className="text-sm text-primary hover:underline" data-testid="immersion-week-nudge-go">Begin {w.nudge.title} →</Link>
        </div>
      )}
      {w.count === 0 && <Link to="/immersions" className="inline-block mt-4 text-xs text-muted-foreground hover:text-foreground transition-colors" data-testid="immersion-week-start">Begin this week's first immersion →</Link>}
    </section>
    </>
  );
}
